import { AppState } from "../constants";
import useApplicationState from "./useApplicationState";
export default () => {
  const [{
    isBot
  } = false] = useApplicationState(AppState.isBot) || [];
  return isBot ? isBot : false;
};